// extracted by mini-css-extract-plugin
module.exports = {"vote":"vote_vote__l1pUD","horizontal":"vote_horizontal__XnHZg","vertical":"vote_vertical__Ky8vD","upvotes":"vote_upvotes__8usC4"};